<script setup>
// PEGI content-descriptor badge: renders the official descriptor pictogram
// (downloaded from pegi.info, like the age labels in RatingBadge) for one
// vg_pegi_descriptors option, falling back to the plain text chip when the
// option (or its asset) is unknown. Detection is by option Code first, then
// by the en_GB label.
const props = defineProps({
  option: { type: Object, required: true }, // { Code, Labels: { en_GB, ... } }
  language: { type: String, default: 'en_GB' },
  imgClass: { type: String, default: 'h-12 w-auto' },
  chipClass: {
    type: String,
    default: 'inline-block px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs border border-gray-200',
  },
});

const failed = ref(false);

const BY_CODE = {
  badlang: 'bad-language',
  discrimination: 'discrimination',
  drugs: 'drugs',
  fear: 'fear',
  gambling: 'gambling',
  in_dsh_game_purchases: 'in-game-purchases',
  sex: 'sex',
  violence: 'violence',
};

const label = computed(
  () => props.option?.Labels?.[props.language] || props.option?.Labels?.en_GB || props.option?.Code || ''
);

const src = computed(() => {
  let key = BY_CODE[String(props.option?.Code || '').trim().toLowerCase()];
  if (!key) {
    const en = String(props.option?.Labels?.en_GB || '').toLowerCase();
    if (en.includes('language')) key = 'bad-language';
    else if (en.includes('discrimination')) key = 'discrimination';
    else if (en.includes('drug')) key = 'drugs';
    else if (en.includes('fear') || en.includes('horror')) key = 'fear';
    else if (en.includes('gambling')) key = 'gambling';
    else if (en.includes('purchase')) key = 'in-game-purchases';
    else if (en.includes('sex')) key = 'sex';
    else if (en.includes('violence')) key = 'violence';
  }
  return key ? `/pegi-icons/pegi-desc-${key}.jpg` : null;
});
</script>

<template>
  <!-- Eager on purpose: tiny local assets; lazy-loading never fires for imgs that
       mount inside collapsed panels (ShowMorePanel / hidden tabs). -->
  <img v-if="src && !failed" :src="src" :alt="label" :title="label" class="inline-block rounded" :class="imgClass"
    decoding="async" @error="failed = true" />
  <span v-else :class="chipClass">{{ label }}</span>
</template>
